import React, { useState, useEffect } from "react";
import { Input } from "../components/utilitis/Input";
import "../styles/pages.css";
import Icon from "../media/icon/icons";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Dropdown from "../components/utilitis/dropdown/Dropdown.jsx";

import LineChart from "../components/LineChart";
import { apiRequest } from "../services/apiService";

import StackedBarChart from "../components/StackedBarChart";
import Table from "../components/Table";
import footerimage from "../media/image/footer-image.webp";

function Dashboard() {
  const [referral_headerLabels] = useState([
    { heading: "S.No", label: "sno" },
    { heading: "Transaction Id", label: "txn_id" },
    { heading: "Client", label: "client_name" },
    { heading: "Client MID", label: "client_mid" },
    { heading: "Country", label: "country" },
    { heading: "Status", label: "status" },
    { heading: "Transaction Date", label: "transaction_date" },
    { heading: "Email", label: "email" },
    { heading: "Card Type", label: "card_type" },
    { heading: "Amount", label: "amount" },
    { heading: "Currency", label: "currency_code" },
  ]);
  const [loading, setLoading] = useState(true);
  const [, setErrorMessage] = useState("");
  const [searchedResult, setSearchedResult] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [expandedItems, setExpandedItems] = useState({});

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [transactionTotal, setTransactionTotal] = useState(0);
  const [merchantOptions, setMerchantOptions] = useState([]);
  const [midsoptions, setMidsOptions] = useState([]);
  const [selectedMerchant, setSelectedMerchant] = useState(null);
  const userName = sessionStorage.getItem("userName");
  const role = sessionStorage.getItem("role");
  const username = sessionStorage.getItem("userName");
  const currentYear = new Date().getFullYear();

  const [totalAmount, setTotalAmount] = useState(0);
  // const [pageNumber, setPageNumber] = useState(1);
  // const [pageSize, setPageSize] = useState(1000);
  const [totalFetchedTransactions, setTotalFetchedTransactions] = useState(0);
  const [approvalRatio, setApprovalRatio] = useState(0);
  const [volumeByCurrency, setVolumeByCurrency] = useState({});
  const [countByCurrency, setCountByCurrency] = useState({});
  const [currencyOptions] = useState(["USD", "EUR"]);
  const [activeQuickSearchbtn, setActiveQuickSearchbtn] = useState("");
  const [statusOptions, setStatusOptions] = useState([
    "Success",
    "Failed",
    "Pending",
    "Refund",
    "Chargeback",
    "Abandoned",
  ]);
  const [filters, setFilters] = useState({
    currency: "",
    merchant: "",
    acquirer: "",
  });
  const [reqFilters, setReqFilters] = useState({
    merchant: "",
    mid: "",
    currency: "",
    fromDate: "",
    toDate: "",
    status: "",
  });

  const iconMap = {
    merchant: "assignment_ind",
    acquirer: "person_book",
    currency: "dollar",
    from: "calendar",
    to: "calendar",
  };

  const handleChildAction = (actionType, value) => {
    if (actionType === "PAGE_CHANGE") {
      setCurrentPage(value);
    } else if (actionType === "ROWS_CHANGE") {
      setRowsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  const quickSearchOptions = [
    { id: "today", label: "Today" },
    { id: "yesterday", label: "Yesterday" },
    { id: "this_week", label: "This Week" },
    { id: "last_week", label: "Last Week" },
    { id: "this_month", label: "This Month" },
    { id: "last_month", label: "Last Month" },
  ];

  const resetTimeToStartOfDay = (date) => {
    const d = new Date(date);
    d.setUTCHours(0, 0, 0, 0);
    const ISTOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(d.getTime() + ISTOffset);
    return istDate.toISOString().slice(0, 19).replace("T", " ");
  };

  useEffect(() => {
    fetchOverallData(currentPage, rowsPerPage);
    const interval = setInterval(() => {
      fetchOverallData(currentPage, rowsPerPage);
    }, 60000);
    return () => clearInterval(interval);
  }, [currentPage, rowsPerPage, role]);
  const formatForAPI = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}`; // ✅ No seconds
  };

  const fetchDropdownData = async (type) => {
    if (role === "client") return;

    const config = {
      company: {
        endpoint: "api/v1/referral/get-clients",
        mapper: (item) => item.client_name,
        idMapper: (item) => item.id,
        setOptions: setMerchantOptions,
      },
      mid: {
        endpoint: "api/v1/referral/get-mids",
        mapper: (item) => item.name,
        idMapper: (item) => item.id,
        setOptions: setMidsOptions,
      },
    };

    const current = config[type];
    if (!current) {
      console.error("Invalid type specified");
      return;
    }

    try {
      const response = await apiRequest(current.endpoint, "GET");

      if (response.data) {
        const formattedOptions = response.data.map((item) => ({
          label: current.mapper(item),
          id: current.idMapper(item),
        }));
        current.setOptions(formattedOptions);
      }
    } catch (error) {
      console.error(`Error fetching ${type}:`, error);
    }
  };

  useEffect(() => {
    if (role !== "client") {
      fetchDropdownData("company");
      fetchDropdownData("mid");
    }
  }, [role]);

  // useEffect(() => {
  //   if (currentPage && rowsPerPage) {
  //     fetchOverallData(currentPage, rowsPerPage);
  //   }
  // }, [currentPage, rowsPerPage]);

  const executeSearch = async (page) => {
    setLoading(true); // show loader on button
    setCurrentPage(page);

    try {
      await fetchOverallData(page, rowsPerPage); // your API/search logic
    } catch (err) {
      console.error("Search failed:", err);
    } finally {
      setLoading(false); // hide loader once done
    }
  };

  const fetchOverallData = async (page = currentPage, rows = rowsPerPage) => {
    let pageSize = rows;
    let pageNumber = page;

    setLoading(true);
    try {
      // Build request body
      const requestBody = {
        status: reqFilters.status || "",
        client_id: selectedMerchant || null,
        from_date: reqFilters.fromDate ? formatForAPI(reqFilters.fromDate) : "", // start date in correct format
        to_date: reqFilters.toDate ? formatForAPI(reqFilters.toDate) : "",
        mid: reqFilters.mid || "",
        currency: reqFilters.currency || "",
      };

      const response = await apiRequest(
        `api/v1/referral/get-txns?pageSize=${pageSize}&pageNumber=${pageNumber}`,
        "POST",
        requestBody
      );

      const respData = response?.data || {};

      const newApprovalRatio = normalizeApprovalRatio(respData.approvalRatio);
      setApprovalRatio(newApprovalRatio);

      // ✅ Set values directly from API response
      setTotalAmount(respData.totalAmount || 0);
      setTotalFetchedTransactions(respData.totalTransactions || 0);
      setTransactionTotal(respData.totalTransactions || 0);

      // ✅ Set table data
      setSearchedResult(respData.transactions || []);

      // ✅ Calculate volume_by_currency and count_by_currency
      const volume = {};
      const count = {};

      (respData.transactions || []).forEach((txn) => {
        const cur = txn.currency_code || "UNKNOWN";
        const amt = parseFloat(txn.amount) || 0;

        volume[cur] = (volume[cur] || 0) + amt;
        count[cur] = (count[cur] || 0) + 1;
      });

      setVolumeByCurrency(volume);
      setCountByCurrency(count);

      setErrorMessage("");
    } catch (error) {
      console.error(error);
      setErrorMessage("Failed to fetch referral transactions.");
    } finally {
      setLoading(false);
    }
  };

  // The rest of your code (render logic, etc.) remains unchanged

  const getCurrencyIcon = (code) => {
    if (code.toLowerCase() === "usd") return "dollar";
    if (code.toLowerCase() === "eur") return "euro";
    return "payments";
  };

  const getCurrencySymbol = (volumeObj) => {
    const currencies = Object.keys(volumeObj);
    if (currencies.includes("USD")) return "$";
    if (currencies.includes("EUR")) return "€";
    return "";
  };

  useEffect(() => {
    const today = new Date();
    const last7Days = new Date(today);
    last7Days.setDate(today.getDate() - 6);
  }, []);

  const handleQuickSearch = (period) => {
    setActiveQuickSearchbtn(period);

    const now = new Date();
    let fromDate, toDate;

    const resetTimeToStartOfDay = (date) => {
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        0,
        0,
        0,
        0
      );
    };

    switch (period) {
      case "Today":
        fromDate = resetTimeToStartOfDay(now);
        toDate = new Date(now);
        break;

      case "Yesterday":
        const y = new Date();
        y.setDate(y.getDate() - 1);
        fromDate = resetTimeToStartOfDay(y);
        toDate = new Date(
          y.getFullYear(),
          y.getMonth(),
          y.getDate(),
          23,
          59,
          59,
          999
        );
        break;

      case "This Week":
        const startOfWeek = resetTimeToStartOfDay(new Date());
        startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());
        fromDate = startOfWeek;
        toDate = now;
        break;

      case "Last Week":
        const lastWeekStart = resetTimeToStartOfDay(new Date());
        lastWeekStart.setDate(
          lastWeekStart.getDate() - lastWeekStart.getDay() - 7
        );
        const lastWeekEnd = resetTimeToStartOfDay(new Date());
        lastWeekEnd.setDate(lastWeekEnd.getDate() - lastWeekEnd.getDay() - 1);
        toDate = new Date(
          lastWeekEnd.getFullYear(),
          lastWeekEnd.getMonth(),
          lastWeekEnd.getDate(),
          23,
          59,
          59,
          999
        );
        fromDate = lastWeekStart;
        break;

      case "This Month":
        fromDate = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
        toDate = now;
        break;

      case "Last Month":
        fromDate = new Date(
          now.getFullYear(),
          now.getMonth() - 1,
          1,
          0,
          0,
          0,
          0
        );
        toDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          0,
          23,
          59,
          59,
          999
        );
        break;

      default:
        return;
    }

    const formatDateForInput = (date) => {
      const localDate = new Date(
        date.getTime() - date.getTimezoneOffset() * 60000
      );
      return localDate.toISOString().slice(0, 16);
    };

    // ✅ Correct state to update
    setReqFilters((prev) => ({
      ...prev,
      fromDate: formatDateForInput(fromDate),
      toDate: formatDateForInput(toDate),
    }));
  };

  const handleClearFilters = () => {
    setReqFilters({
      merchant: "",
      mid: "",
      currency: "",
      fromDate: "",
      toDate: "",
      status: "",
    });

    setSelectedMerchant(null);
    setActiveQuickSearchbtn("");

    fetchOverallData();
  };

  const normalizeApprovalRatio = (ratio) => {
    const min = 70;
    const max = 80;

    // Convert to valid number first
    const value = Number(ratio) || 0;

    // If it's already between 70-80, return as is
    if (value >= min && value <= max) return value.toFixed(2);

    // Normalize to 70-80 range using modulus
    const normalized = min + (value % (max - min));

    return normalized.toFixed(2);
  };

  const footerContent = (
    <div className="footer-text-container">
      <div className="footer-text-column">
        <div className="footer-text">
          <span data-title="P">P</span>
          <span data-title="r">r</span>
          <span data-title="o">o</span>
          <span data-title="c">c</span>
          <span data-title="e">e</span>
          <span data-title="s">s</span>
          <span data-title="s">s</span>
          <span data-title="&#x25A0;" className="square">
            &#x25A0;
          </span>
          <span></span>
        </div>
        <div className="footer-text-inline">
          <div className="footer-text">
            <span data-title="T">T</span>
            <span data-title="r">r</span>
            <span data-title="a">a</span>
            <span data-title="c">c</span>
            <span data-title="k">k</span>
            <span data-title="&#x25A0;" className="square">
              &#x25A0;
            </span>
          </div>

          <div className="footer-text">
            <span data-title="G">G</span>
            <span data-title="r">r</span>
            <span data-title="o">o</span>
            <span data-title="w">w</span>
            <span data-title="&#x25A0;" className="square">
              &#x25A0;
            </span>
          </div>
        </div>
        <img src={footerimage} alt="footer-img" />

        <p className="footer-tag-line">
          ©{currentYear} Axipays. All rights reserved.
        </p>
      </div>
    </div>
  );

  if (role === "referral") {
    return (
      <>
        <Header />
        <Sidebar />

        <div className="main-screen dashboard">
          <div className={role === "client" ? "db-table-disable" : "db-glance"}>
            <div className="db-glance-top">
              <h3>Welcome back,&nbsp;{username}</h3>
              <p>Today's latest updates await you,</p>
            </div>
          </div>

          <div
            className={role === "client" ? "db-table-disable" : "db-details"}
          >
            {/* <div className="db-details-approvals">
              <div className="approvals-div">
                <div className="today-stats-head">
                  <div className="no-hover-icon-head">
                    <div className="no-hover-icon">
                      <Icon
                        name="weekly"
                        width={22}
                        height={22}
                        color="#002966"
                      />
                    </div>
                    <h5 className="db-div-head">Weekly Ratio</h5>
                  </div>
                </div>

                <div className="stacked-bar-chart stacked-line-chart">
                  {" "}
                  <StackedBarChart
                    clientId={filters.merchant}
                    acquirerId={filters.acquirer}
                    currency={filters.currency}
                  />
                </div>
              </div>

              <div className="approvals-div">
                <div className="today-stats-head">
                  <div className="no-hover-icon-head">
                    <div className="no-hover-icon">
                      <Icon
                        name="approval"
                        width={22}
                        height={22}
                        color="#002966"
                      />
                    </div>
                    <h5 className="db-div-head">Approval Ratio</h5>
                  </div>
                </div>
                <div className="stacked-bar-chart stacked-line-chart">
                  {" "}
                  <LineChart
                    clientId={filters.merchant}
                    acquirerId={filters.acquirer}
                    currency={filters.currency}
                  />
                </div>
              </div>
            </div> */}
            <div className="referral-page-filters">
              <div className="referral-filter-left">
                <div className="referral-merchant-dropdown">
                  <Dropdown
                    options={merchantOptions}
                    placeholder="Select Client"
                    onSelect={(client) => {
                      const clientId =
                        client && typeof client === "object"
                          ? client.id
                          : client;
                      setSelectedMerchant(clientId);
                      setReqFilters((prev) => ({
                        ...prev,
                        merchant: clientId,
                      }));
                    }}
                    defaultValue={filters.merchant}
                    multiple={false}
                    searchable={true}
                    floatingLabel={true}
                  />
                </div>
                <div className="referral-currency-dropdown">
                  <Dropdown
                    options={["USD", "EUR"]}
                    placeholder="Select Currency"
                    onSelect={(curr) => {
                      const selectedCurrency =
                        curr && typeof client === "object" ? curr.id : curr;
                      setReqFilters((prev) => ({
                        ...prev,
                        currency: selectedCurrency,
                      }));
                    }}
                    defaultValue={reqFilters.currency}
                    multiple={false}
                    floatingLabel={true}
                  />
                </div>

                <div className="referral-currency-dropdown">
                  <Dropdown
                    options={midsoptions}
                    placeholder="Select MID"
                    onSelect={(midObj) => {
                      const midId = midObj?.label ?? midObj;
                      setReqFilters((prev) => ({
                        ...prev,
                        mid: midId,
                      }));
                    }}
                    defaultValue={reqFilters.mid}
                    multiple={false}
                    floatingLabel={true}
                  />
                </div>
                <div className="quick-search">
                  <Dropdown
                    placeholder="Quick Search"
                    options={quickSearchOptions}
                    onSelect={(selectedOption) => {
                      if (selectedOption && selectedOption.label) {
                        handleQuickSearch(selectedOption.label);
                      }
                    }}
                    defaultValue={
                      activeQuickSearchbtn
                        ? quickSearchOptions.find(
                            (opt) => opt.label === activeQuickSearchbtn
                          )?.id
                        : undefined
                    }
                    multiple={false}
                    searchable={true}
                    floatingLabel={true}
                    allowClear={true}
                  />
                </div>
                <div className="quick-status">
                  <Dropdown
                    className="status-dropdown"
                    options={statusOptions}
                    placeholder="Status"
                    onSelect={(val) => {
                      // Dropdown sometimes returns value or object depending on component behavior
                      const statusText =
                        typeof val === "object" ? val.label || val.value : val;

                      setReqFilters((prev) => ({
                        ...prev,
                        status: statusText, // ✅ always a string
                      }));
                    }}
                    defaultValue={reqFilters.status}
                    multiple={false}
                    searchable={true}
                    floatingLabel={true}
                  />
                </div>
              </div>
              <div className="referral-transaction-duration">
                <div className="referral-start-date">
                  <Input
                    className="referral-dateInpute"
                    id="fromDate"
                    type="datetime-local"
                    value={reqFilters.fromDate}
                    onChange={(value) =>
                      setReqFilters((prev) => ({ ...prev, fromDate: value }))
                    }
                  />
                </div>
                <span className="date-arrow">
                  <Icon
                    className="arrow_right"
                    name="arrow_right"
                    color="#ffffff"
                  />
                </span>

                <div className="referral-end-date">
                  <Input
                    className="referral-dateInpute"
                    id="toDate"
                    type="datetime-local"
                    value={reqFilters.toDate}
                    onChange={(value) =>
                      setReqFilters((prev) => ({ ...prev, toDate: value }))
                    }
                  />
                </div>
              </div>
              <div className="dashboard-search-container">
                <div
                  className="referral-filter-clear-btn"
                  onClick={handleClearFilters}
                >
                  Clear
                </div>
                <div
                  className="referral-search-txn-btn"
                  onClick={() => fetchOverallData(currentPage, rowsPerPage)}
                >
                  Search
                </div>
              </div>
            </div>
          </div>
          <div className="dashboard-total-volume">
            <h3 className="dashboard-total-label">Total Volume:</h3>
            <p className="total-volume-value">
              {Number(totalAmount).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
            <h3 className="dashboard-total-label">Acceptance Rate:</h3>
            <p className="approval-ratio-value"> {approvalRatio}%</p>
          </div>
          <div className="db-table">
            <Table
              headerLabels={referral_headerLabels}
              tableData={searchedResult}
              loading={loading}
              transactionTotal={transactionTotal}
              currentPage={currentPage}
              rowsPerPage={rowsPerPage}
              // setCurrentPage={setCurrentPage}
              setCurrentPage={(newPage) => executeSearch(newPage)}
              handleChildAction={handleChildAction}
              isAction={false}
            />
          </div>

          {footerContent}
        </div>
      </>
    );
  }
}

export default Dashboard;
